<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Tareas</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Tareas</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarProceso">
                <i class="fa fa-plus"></i> Agregar Tarea
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar Tareas"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables 
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <editar-proceso ref="refEditarProceso" @actualizaProcesos="buscar()"></editar-proceso>
    
    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarProceso"
      @ok="eliminarProceso();"
      @cancel="modalEliminarProceso = false"
    >¿Está seguro que quiere desactivar esta tarea?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarProceso"
      @ok="activarProceso();"
      @cancel="modalActivarProceso = false"
    >¿Está seguro que quiere activar esta tarea?</b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import EditarProceso from "./EditarProceso";

export default {
  name: "Procesos",
  mixins: [tablasMixin, globalesMixin],
  components: {
    cSwitch,
    EditarProceso
  },
  data: function() {
    return {
      tieneAcceso: true,

      modalEliminarProceso: false,
      modalActivarProceso: false,
      modalAgregarProceso: false,
      procesoSelected: null,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      data: [],
      titles: [
        /*
        {
          prop: "gspnombre",
          label: "Nombre"
        },*/
        {
          prop: "gspdescripcion",
          label: "Descripción"
        },
        /*
        {
          prop: "gspclave1",
          label: "Glosa Clave 1"
        },
        {
          prop: "gspclave2",
          label: "Glosa Clave 2"
        },
        {
          prop: "gspclave3",
          label: "Glosa Clave 3"
        },
        */
        {
          prop: "desc_estado",
          label: "Estado Inicial"
        },
        {
          prop: "desc_actividad",
          label: "Actividad Inicial"
        },
        {
          prop: "desc_gsptipo",
          label: "Tipo"
        },
        /*
        {
          prop: "gsprol",
          label: "Rol"
        },
        */
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filters: [
        {
          prop: [
            /*
            "gspnombre",
            */
            "gspdescripcion",
            /*
            "gspclave1",
            "gspclave2",
            "gspclave3",
            */
            "desc_estado",
            "desc_actividad",
            "desc_gsptipo",
            /*
            "gsprol",
            */
            "desc_activo",
          ],
          value: ""
        }
      ]
    };
  },
  methods: {
    
    customButtonsForRow(row) {
      if ((row.gspnombre != 'Enviar a cobran') && (row.gspnombre != 'Enviar a liquid')){
        if (row.gspactivo === 0) {
          return [
            {
              name: " Activar",
              icon: "fa fa-plus",
              type: "success",
              handler: _ => {
                this.$session.start();
                this.modalActivarProceso = true;
                this.procesoSelected = row.gspnombre;
              }
            }
          ];
        } else {
          return [
            {
              name: " Configurar",
              icon: "fa fa-cogs",
              type: "primary",
              handler: _ => {
                this.configurar(row.gspnombre, row.gspdescripcion);
              }
            },
            {
              name: " Modificar",
              icon: "fa fa-pencil",
              type: "primary",
              handler: _ => {
                this.$refs.refEditarProceso.modalEditarProceso = true;
                this.$refs.refEditarProceso.visible = true;
                this.$refs.refEditarProceso.obtenerProceso(
                  this.$session.get("mail"),
                  this.$session.get("usuarioInterno"),
                  row.gspnombre,
                  "MOD"
                );
              }
            },
            {
              name: " Desactivar",
              icon: "fa fa-trash",
              type: "danger",
              handler: _ => {
                this.$session.start();
                this.modalEliminarProceso = true;
                this.procesoSelected = row.gspnombre;
              }
            }
          ];
        }
      }else{
        return [
            {
              name: " Configurar",
              icon: "fa fa-cogs",
              type: "primary",
              handler: _ => {
                this.configurar(row.gspnombre, row.gspdescripcion);
              }
            }

          ];
      }
    },
    
    buscar(p_pricodigo) {
      this.$Progress.start();

      return apiActividades
        .buscarProcedimiento(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_pricodigo,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$router.push({ path: "procesos" });
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.$moment(row[column.property]).format("DD-MM-YYYY");
      } else if (column.property == "pricodnum" && row[column.property]) {
        column.align = "is-right";
        return this.$numeral(row[column.property]).format("0");
      } else {
        return row[column.property];
      }
    },
    
    agregarProceso() {
      this.$refs.refEditarProceso.modalAgregarProceso = true;
      this.$refs.refEditarProceso.visible = true;
      this.$refs.refEditarProceso.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        ""
      );
    },

    eliminarProceso() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .eliminarProcedimiento(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.procesoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gspnombre"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalEliminarProceso = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarProceso() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .activarProcedimiento(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.procesoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gspnombre"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalActivarProceso = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    configurar(proceso, desc_proceso){
      event.preventDefault();
      this.$Progress.start();

      this.$router.push({ path: 'configuracion', query: { gspnombre: proceso, desc_gspnombre: desc_proceso, procesos: 'procesos' }});

      this.$Progress.finish();
    }
    
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.buscar("");
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
      this.$router.push({ path: "procesos" });
    }
  }
};
</script>
